<template>
  <div class="test-end">
    <div class="icon-complete">
      <img src="/static/images/elements/icon_ok.svg" />
    </div>

    <div class="testend-title">
      {{ $tr('interview.tests.end.title') }}<br />
      {{ $tr('videoInterview.end.thanksWithoutName') }}
    </div>

    <div class="description">{{ $tr('interview.tests.end.answersSend') }}</div>

    <div class="btns">
      <vbutton
        v-if="is_record || module_integration"
        :text="$tr('interview.tests.endTime.next')"
        @click="next_stage"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'TestEnd',

    props: {
      active_modules: {
        type: Array,
        default: () => []
      },

      item: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        iconStyle: {
          marginTop: '5px',
          marginLeft: '3px'
        }
      };
    },

    computed: {
      ...mapGetters('tests_test', ['token']),

      module_test() {
        if (!this.active_modules) {
          return false;
        }
        return this.active_modules.find(el => el.id === 'test');
      },

      module_survey() {
        if (!this.active_modules) {
          return false;
        }
        return this.active_modules.find(el => el.id === 'survey');
      },

      module_integration() {
        if (!this.active_modules) {
          return false;
        }
        return this.active_modules.find(el => el.id === 'integration');
      },

      is_record() {
        if (!this.active_modules) {
          return false;
        }
        return this.active_modules.find(el => el.id === 'videointerview');
      }
    },

    methods: {
      ...mapMutations('interview/videointerview', { nextStage: 'next_stage' }),

      next_stage() {
        this.nextStage();

        if (this.item.stage.id === 'videointerview') {
          this.$router.push({ path: `/record/${this.token}` });
        } else if (this.item.stage.id === 'integration') {
          this.$router.push({ path: `/external-integration/${this.token}` });
        } else {
          this.$router.push({ path: `/record/${this.token}` });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.test-end {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: #233346;

  .icon-complete {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;
  }

  .testend-title {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    margin: 0 auto 20px;
  }

  .description {
    font-size: 15px;
    line-height: 24px;
    margin: 0 auto;
  }

  .btns {
    display: flex;
    padding-top: 10px;

    &__button {
      display: block;
      padding: 9px 20px;
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      cursor: pointer;
      margin: 10px auto 20px;
      border-radius: 2px;

      &_to-stage {
        background: $green;
        color: #ffffff;
      }

      &_to-vacancy {
        background: #f4f5f7;
        color: $green;
        margin-left: 20px;
      }
    }
  }
}
</style>
